import type { TechMeasureRecommendation } from '@/types';

export const allRecommendations: TechMeasureRecommendation[] = [
  {
    index: '01',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '五日生化需氧量去除率与污泥龄密切相关。因此，为了达到污水处理厂的五日生化需氧量质量，必须进行准确的泥龄调整。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '02',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '化学需氧量去除率与污泥龄密切相关。因此，为了达到废水处理厂的 化学需氧量 质量，必须进行准确的污泥龄调整。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量']
  },
  {
    index: '03',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '过滤介质的生物污染可能导致大肠菌群不合规。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['大肠杆菌群 [细菌数/100毫升]']
  },
  {
    index: '04',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '过滤介质的生物污染可能导致大肠菌群不合规。为了避免这种情况，需要定期进行杀菌剂处理。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['大肠杆菌群 [细菌数/100毫升]']
  },
  {
    index: '05',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '正确选择絮凝剂和投加量是首要的（需要实验室小剂量样品测试）',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '硫化物',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '总氮',
      '油和油脂',
      '化学需氧量',
      '总磷',
      '总悬浮物',
      '5日生化需氧量'
    ]
  },
  {
    index: '06',
    typeId: 'wastewater',
    category: ['活性炭过滤器', '砂滤池'],
    text: '压差测量表明过滤器污染。一旦污染了，就应该开始清洁。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: [
      '铜',
      '总氮',
      '苯酚',
      '镉',
      '钴',
      '可吸收有机卤素',
      '化学需氧量',
      '银',
      '总磷',
      '汞',
      '全价铬',
      '5日生化需氧量',
      '铅',
      '锌',
      '砷',
      '总悬浮物',
      '六价铬',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '镍'
    ]
  },
  {
    index: '07',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '大部分可溶性有色染料（高分子量和低极性，如橙黄色染料）预计会保留在活性炭纤维中。等电点pH值对于吸附增强很重要。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['顏色  [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '08',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '氨氮不达标可能是由于不正确的硝化作用造成的。在好氧反应器中发生硝化，即氨态氮转化为硝酸盐。为此，反应器必须适应硝化细菌的存在，并且污泥龄必须足够（超过 15 天，并且必须根据温度值进行调整）',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['Ammonium-N']
  },
  {
    index: '09',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '应根据要控制的化学参数的类型来选择活性炭的性质。应根据过滤器制造商的建议选择颗粒粒径、孔径和活性碳类型',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: [
      '钴',
      '锌',
      '砷',
      '铜',
      '锑',
      '可吸收有机卤素',
      '镍',
      '银',
      '汞',
      '总悬浮物',
      '六价铬',
      '全价铬',
      '铅',
      '苯酚',
      '镉'
    ]
  },
  {
    index: '10',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '应根据要控制的化学参数的类型来选择活性炭的性质。应根据过滤器制造商的建议选择颗粒粒径、孔径和碳类型。  检查您的水成分是否发生变化，以及是否需要更改碳类型或颗粒粒径。请记住，极性和低分子量物质在活性炭孔隙上的保留很弱。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['5日生化需氧量', '总磷']
  },
  {
    index: '11',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '应根据要控制的化学参数的类型来选择活性炭的性质。应根据过滤器制造商的建议选择颗粒粒径、孔径和碳类型。检查您的水成分是否发生变化，以及是否需要更改碳类型或颗粒粒径。请记住，极性和低分子量物质在活性炭孔隙上的保留很弱。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '12',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '吸附是一个放热过程。因此，活性炭的容量随着温度的升高而降低。对于非常高的温度，预计吸附能力会下降。对于当前温度范围（10 至 30°C），预计不会产生影响。  因此，必须检查水温是否正确。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['钴', '砷', '六价铬', '镉']
  },
  {
    index: '13',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '吸附是一个放热过程。因此，活性炭的吸附能力随着温度的升高而降低。对于非常高的温度，预计吸附能力会下降。对于当前温度范围（10 至 30°C），预计不会产生影响。  因此，必须检查水温是否正确。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: [
      '锌',
      '铜',
      '锑',
      '总氮',
      '全价铬',
      '化学需氧量',
      '镍',
      '银',
      '总磷',
      '总悬浮物',
      '汞',
      '5日生化需氧量',
      '铅',
      '苯酚'
    ]
  },
  {
    index: '14',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '吸附是一个放热过程。因此，活性炭的吸附能力着温度的升高而降低。对于非常高的温度，预计吸附能力会下降。对于当前的温度范围（10 至 30°C），预计不会产生任何影响。因此，必须检查水温是否正确。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['顏色  [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '15',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '吸附是一个放热过程。因此，活性炭的吸附能力随着温度的升高而降低。对于非常高的温度，预计吸附能力会下降。对于当前的温度范围（10 至 30°C），预计不会产生任何影响。因此，必须检查水温是否正确。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['可吸收有机卤素']
  },
  {
    index: '16',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '为了分离六价铬氢氧化物，需要有效的絮凝。正确选择絮凝剂和投加量是首要的（需要实验室小样测试）',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['六价铬']
  },
  {
    index: '17',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '为了分离锑三价铁聚集体，需要有效的絮凝。正确选择絮凝剂和投加量是首要的（需要实验室小样测试）',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['锑']
  },
  {
    index: '18',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '为了分离砷的氢氧化物，需要有效的絮凝。正确选择絮凝剂和投加量是首要的（需要实验室小样测试）',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['砷']
  },
  {
    index: '19',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '为了分离氢氧化镉，需要有效的絮凝。正确选择絮凝剂和投加量是首要的（需要实验室小样测试）',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['镉']
  },
  {
    index: '20',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '为了分离氢氧化铬，需要有效的絮凝。正确选择絮凝剂和投加量是首要的（需要实验室小样测试）。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['全价铬']
  },
  {
    index: '21',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '为了分离氢氧化铜，需要有效的絮凝。正确选择絮凝剂和投加量是首要的（需要实验室小样测试）',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['铜']
  },
  {
    index: '22',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '为了分离氢氧化铅，需要有效的絮凝。正确选择絮凝剂和投加量是首要的（需要实验室小样测试）',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['铅']
  },
  {
    index: '23',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '为了分离氢氧化汞，需要有效的絮凝。正确选择絮凝剂和投加量是首要的（需要实验室小样测试）',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['汞']
  },
  {
    index: '24',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '为了分离氢氧化镍，需要有效的絮凝。正确选择絮凝剂和投加量是首要的（需要实验室小样测试）',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['镍']
  },
  {
    index: '25',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '为了分离氢氧化银，需要有效的絮凝。正确选择絮凝剂和投加量是首要的（需要实验室小样测试）',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['银']
  },
  {
    index: '26',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '为了分离氢氧化锌，需要有效的絮凝。正确选择絮凝剂和投加量是首要的（需要实验室小样测试）',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['锌']
  },
  {
    index: '27',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '锑可以吸附在三价铁上。诸如聚合硫酸铁和氯化铁的试剂是合适的。  建议处理的 pH 值在 5 到 6 之间。估计吸附容量约为 350 mg Sb/g 三价铁',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['锑']
  },
  {
    index: '28',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '锑不能络合。这意味着它们不能形成复合物。金属络合物是其中一个或多个金属原子与一个或多个配体键合的化合物。配体是一种能够通过一个或多个原子与金属中心结合的有机化合物。因此，金属必须是游离的，以便可以通过物理化学处理将其去除。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['锑']
  },
  {
    index: '29',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '锑对活性污泥具有生物毒性，应避免在反应器入口处使用，使之没有化学反应，避免在活性污泥中积累。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['锑']
  },
  {
    index: '30',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '砷不能络合。这意味着它们不能形成复合物。金属络合物是其中一个或多个金属原子与一个或多个配体键合的化合物。配体是一种能够通过一个或多个原子与金属中心结合的有机化合物。因此，金属必须是游离的，以便可以通过物理化学处理将其去除。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['砷']
  },
  {
    index: '31',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '浓度 > 0.1 ppm 的砷对活性污泥具有生物毒性，应避免在反应器入口处使用。使之没有化学反应，避免在活性污泥中积累。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['砷']
  },
  {
    index: '32',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '通过物理化学处理分离的砷必须处于氧化态 5+（砷酸盐）。 砷3+ 不可去除，应使用现有氧化剂（例如次氯酸钠）氧化为 5+。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['砷']
  },
  {
    index: '33',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '砷5+可以通过与氢氧化铁共沉淀来去除。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['砷']
  },
  {
    index: '34',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '砂滤器输出处的 TSS 浓度预计低于 2.5 ppm (< 5 NTU)。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['总悬浮物']
  },
  {
    index: '35',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '可生物降解的化学需氧量（kg/d）应根据食品质量 F/M（kg b化学需氧量/d/kgVSS）设计参数。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量']
  },
  {
    index: '36',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '镉可以在 pH 6.5 下与氢氧化铁共沉淀，也可以在 pH 8.5 - 10 下用有机硫化物和石灰沉淀过滤去除。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['镉']
  },
  {
    index: '37',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '镉不能络合。这意味着它们不能形成复合物。金属络合物是其中一个或多个金属原子与一个或多个配体键合的化合物。配体是一种能够通过一个或多个原子与金属中心结合的有机化合物。因此，金属必须是游离的，以便可以通过物理化学处理将其去除。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['镉']
  },
  {
    index: '38',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '镉在浓度 > 1 至 10 ppm 时对活性污泥具有生物毒性，应避免在反应器入口处使用。使之没有化学反应，避免在活性污泥中积累。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['镉']
  },
  {
    index: '39',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '建议营地数量 20.000-50.000 u。注：坎数 (Gt) 是速度梯度 (G, s-1) 与水力停留时间 (HRT) 的乘积。  该参数广泛用于设计快速混合和絮凝过程。准确的营数必须通过罐子测试实验获得。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '锌',
      '硫化物',
      '砷',
      '铜',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '油和油脂',
      '镍',
      '银',
      '汞',
      '六价铬',
      '全价铬',
      '铅',
      '镉'
    ]
  },
  {
    index: '40',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '建议营地数量 20.000-50.000 u。注：坎数 (Gt) 是速度梯度 (G, s-1) 与水力停留时间 (HRT) 的乘积。该参数广泛用于设计快速混合和絮凝过程。准确的营数必须通过罐子测试实验获得。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总悬浮物']
  },
  {
    index: '41',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '检查 OD 水平。必须在 2 到 4 ppm 之间',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量', '5日生化需氧量']
  },
  {
    index: '42',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '检查 OD 水平。必须在 2 到 4 ppm 之间（在硝化步骤中）',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总氮']
  },
  {
    index: '43',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '检查 OD 水平。在有氧步骤中，它必须介于 2 和 4 ppm 之间。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总磷']
  },
  {
    index: '44',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '检查pH值，并根据待吸附物质的酸性/碱性性质进行调节：酸性可吸附物质在酸性pH值下吸附效果最佳。相反，碱性可吸附物质在碱性pH值下吸附效果最好。如果您的 pH 值不正确：如果您需要降低 pH 值，请添加酸性试剂；如果您需要提高 pH 值，则必须添加碱性试剂',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: [
      '可吸收有机卤素',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '总氮',
      '化学需氧量',
      '总磷',
      '5日生化需氧量',
      '苯酚'
    ]
  },
  {
    index: '45',
    typeId: 'wastewater',
    category: ['凝结', '絮凝', '收集池'],
    text: '化学混凝和絮凝工艺建议在 30°C 以下进行。因此，必须检查进入混凝反应器（收集池内）的水温是否低于30℃。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['锌', '油和油脂', '镍', '银', '总磷', '总悬浮物', '汞', '铅']
  },
  {
    index: '46',
    typeId: 'wastewater',
    category: ['凝结', '絮凝'],
    text: '化学混凝和絮凝工艺建议在 30°C 以下进行。因此，必须检查进入混凝反应器（收集池内）的水温是否低于30℃。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '锌',
      '硫化物',
      '砷',
      '铜',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '油和油脂',
      '全价铬',
      '镍',
      '银',
      '总悬浮物',
      '六价铬',
      '5日生化需氧量',
      '铅',
      '镉'
    ]
  },
  {
    index: '47',
    typeId: 'wastewater',
    category: ['收集池'],
    text: '化学混凝和絮凝工艺建议在30℃以下进行。因此，必须检查进入混凝反应器（收集池中）的水温低于30℃。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['砷']
  },
  {
    index: '48',
    typeId: 'wastewater',
    category: ['收集池'],
    text: '化学混凝和絮凝工艺建议在30℃以下进行。因此，必须检查进入混凝反应器（收集池中）的水温低于30℃。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '锌',
      '硫化物',
      '铜',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '银',
      '汞',
      '总悬浮物',
      '六价铬',
      '铅',
      '镉'
    ]
  },
  {
    index: '49',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '化学混凝对不溶性 5日生化需氧量 的作用与 TSS 相同。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '50',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '化学混凝对不溶性 化学需氧量 的作用与 TSS 相同。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '51',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '化学混凝对不溶性总氮的作用与 TSS 相同。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '52',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '使用氢氧化钠作为试剂，在 pH 7.5 时达到 3+ 氢氧化铬的最小溶解度。由于形成的沉淀物会被重新稀释，因此沉淀物对 pH 值很敏感。当使用石灰共沉淀时，在 pH 8 下操作时可以达到更好的结果，并且反应对 pH 的依赖性较小。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['全价铬']
  },
  {
    index: '53',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '浓度 > 1 ppm 的 6+ 铬对​​活性污泥具有生物毒性，应避免在反应器入口处使用。预计无需治疗。  应避免在活性污泥中积累。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['六价铬']
  },
  {
    index: '54',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '六价铬不能络合。这意味着它们不能形成复合物。金属络合物是其中一个或多个金属原子与一个或多个配体键合的化合物。配体是一种能够通过一个或多个原子与金属中心结合的有机化合物。因此，金属必须是游离的，以便可以通过物理化学处理将其去除。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['六价铬']
  },
  {
    index: '55',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '通过物理化学处理分离的铬必须处于还原态 3+。 铬6+ 不可去除，应使用电流还原剂如焦亚硫酸钠、硫代硫酸钠、硫酸亚铁等将其还原至 3+。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['六价铬']
  },
  {
    index: '56',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '混凝对pH值非常敏感。铝需要 6.5 至 7.5 u 的值。铁从 7 到 8 u。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['化学需氧量', '5日生化需氧量', '总氮', '总悬浮物']
  },
  {
    index: '57',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '混凝对pH值非常敏感。铁需要 7 到 8 u 的值。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['硫化物']
  },
  {
    index: '58',
    typeId: 'wastewater',
    category: ['格栅'],
    text: '建议先粗筛，再细筛，过滤尺寸 <1-3 毫米。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '铜',
      '总氮',
      '镉',
      '钴',
      '化学需氧量',
      '银',
      '总磷',
      '汞',
      '全价铬',
      '5日生化需氧量',
      '铅',
      '锌',
      '砷',
      '总悬浮物',
      '六价铬',
      '硫化物',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '镍'
    ]
  },
  {
    index: '59',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '钴对活性污泥具有生物毒性，应避免在反应器入口处使用。使之没有化学反应，避免在活性污泥中积累。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['钴']
  },
  {
    index: '60',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '接触时间应足够（HRT）> 10 分钟',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '硫化物',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '总氮',
      'PH值',
      '化学需氧量',
      '油和油脂',
      '总悬浮物',
      '5日生化需氧量'
    ]
  },
  {
    index: '61',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '接触时间应足够（HRT）> 15 分钟',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '锌',
      '硫化物',
      '砷',
      '铜',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '油和油脂',
      '化学需氧量',
      '全价铬',
      '镍',
      '银',
      '总磷',
      '总悬浮物',
      '六价铬',
      '汞',
      '5日生化需氧量',
      '铅',
      '镉'
    ]
  },
  {
    index: '62',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '剧烈混合后，接触时间应足够 (HRT) > 10 分钟',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '锌',
      '砷',
      '铜',
      '锑',
      '镍',
      '银',
      '总磷',
      '六价铬',
      '汞',
      '全价铬',
      '铅',
      '镉'
    ]
  },
  {
    index: '63',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '使用氢氧化钠调节至 pH 8 或使用石灰调节至 pH 8-9，可以将铜沉淀为氢氧化物。使用石灰时预计会有更好的效果。对于较低浓度的流出物值，建议在 pH 8.5 下使用有机硫化物进行沉淀。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['铜']
  },
  {
    index: '64',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '铜不能络合。这意味着它们不能形成复合物。金属络合物是其中一个或多个金属原子与一个或多个配体键合的化合物。配体是一种能够通过一个或多个原子与金属中心结合的有机化合物。因此，金属必须是游离的，以便可以通过物理化学处理将其去除。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['铜']
  },
  {
    index: '65',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '浓度 > 1.0 ppm 的铜对活性污泥具有生物毒性，应避免在反应器入口处使用。使之没有化学反应，避免在活性污泥中积累。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['铜']
  },
  {
    index: '66',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '使用从澄清器底部到反应罐的部分循环可以增强共沉淀和吸附。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '锌',
      '砷',
      '铜',
      '锑',
      '镍',
      '银',
      '汞',
      '六价铬',
      '全价铬',
      '铅',
      '镉'
    ]
  },
  {
    index: '67',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '目前生物反应器中的工艺温度范围为 16 至 22°C，推荐范围为 18-20°C。 < 16°C 的低温会显著减慢生物过程。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量', '5日生化需氧量', '总氮', '总磷']
  },
  {
    index: '68',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '反硝化需要精确的反应器设计、反应体积中的高 F/M 和快速的生化需氧量。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总氮']
  },
  {
    index: '69',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '由于反应器内的硝化氮、沉降器中的污泥停留时间较长，可能会因气体截留和排放中的 总悬浮固体损失而导致污泥浮选反硝化。最终化学需氧量将会受到影响。精确的回收控制和回收中的氧化还原控制将有助于控制该项目。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总氮']
  },
  {
    index: '70',
    typeId: 'wastewater',
    category: ['凝结', '絮凝', '收集池'],
    text: '混合会产生泡沫。建议使用泡沫抑制剂。硅基消泡剂与过滤合成膜不兼容。替代方案：基于烷基烃中有机酸的酯和盐以及脂肪酸盐的混合物的商业产品。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['持久性泡沫']
  },
  {
    index: '71',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '需要投加足够的混凝剂。强烈建议先在实验室进行小剂量烧杯测试',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '硫化物',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '总氮',
      '油和油脂',
      '化学需氧量',
      '总磷',
      '总悬浮物',
      '5日生化需氧量'
    ]
  },
  {
    index: '72',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '需要添加足够的混凝剂/金属沉淀剂。强烈先在实验室进行小剂量烧杯测试',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '锌',
      '砷',
      '铜',
      '锑',
      '镍',
      '银',
      '汞',
      '六价铬',
      '全价铬',
      '铅',
      '镉'
    ]
  },
  {
    index: '73',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '极低的 pH 值 (< 2-4) 会损害沙子的耐久性和稳定性',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: [
      '钴',
      '锌',
      '砷',
      '铜',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '总氮',
      '全价铬',
      '化学需氧量',
      '镍',
      '银',
      '总磷',
      '总悬浮物',
      '六价铬',
      '汞',
      '5日生化需氧量',
      '铅',
      '镉'
    ]
  },
  {
    index: '74',
    typeId: 'wastewater',
    category: ['活性炭过滤器', '砂滤池'],
    text: '过滤器清洗频率：建议每天',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: [
      '铜',
      '总氮',
      '镉',
      '钴',
      '可吸收有机卤素',
      '化学需氧量',
      '银',
      '总磷',
      '汞',
      '全价铬',
      '5日生化需氧量',
      '铅',
      '锌',
      '砷',
      '总悬浮物',
      '六价铬',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '镍'
    ]
  },
  {
    index: '75',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '过滤器清洗频率：建议每天。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['苯酚', '总磷']
  },
  {
    index: '76',
    typeId: 'wastewater',
    category: ['活性炭过滤器', '砂滤池'],
    text: '过滤介质可能受到生物污染。建议进行程序化消毒清洗。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: [
      '铜',
      '总氮',
      '苯酚',
      '镉',
      '钴',
      '可吸收有机卤素',
      '化学需氧量',
      '银',
      '总磷',
      '汞',
      '全价铬',
      '5日生化需氧量',
      '铅',
      '锌',
      '砷',
      '总悬浮物',
      '六价铬',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '镍'
    ]
  },
  {
    index: '77',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '过滤介质容量控制是首要的。应保留废水中存在的可溶性 可吸收有机卤素 作为参考。并且应该定期在滤波器的输入和输出处进行测试。需要处理过的水流量数据。使用这些值操作员应该知道以下之间的关系： 过滤器中颗粒活性炭对特定化学参数的吸附能力，单位是每千克活性炭吸附的该化学参数的千克数。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['可吸收有机卤素']
  },
  {
    index: '78',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '过滤介质容量控制是关键。废水中存在的可溶性和可吸附性五日生化需氧量应作为参考。并且应该定期在滤波器的输入和输出端进行测试。需要处理过的水流量数据。使用这些值，操作人员应该知道以下之间的关系：过滤器中颗粒活性炭对特定化学参数的吸附能力，单位是每千克活性炭吸附的该化学参数的千克数。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '79',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '过滤介质容量控制是关键。废水中存在的可溶性和可吸附性化学需氧量应记录作为参考。并且应该在滤波器的输入和输出端定期进行测试。需要处理过的水流量数据。使用这些值，操作员应该知道以下两者之间的关系：过滤器中颗粒活性炭对特定化学参数的吸附能力，单位是每千克活性炭吸附的该化学参数的千克数。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '80',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '过滤介质容量控制是关键。废水中存在的可溶性和可吸附性氮应保留为参考。并且应该在滤波器的输入和输出端定期进行测试。需要处理过的水流量数据。使用这些值，操作员应该知道以下两者之间的关系：过滤器中颗粒活性炭对特定化学参数的吸附能力，单位是每千克活性炭吸附的该化学参数的千克数。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '81',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '过滤介质容量控制是关键。废水中存在的可溶性和可吸附性磷应保留为参考。并且应该在滤波器的输入和输出端定期进行测试。需要处理过的水流量数据。使用这些值，操作员应该知道以下两者之间的关系：过滤器中颗粒活性炭对特定化学参数的吸附能力，单位是每千克活性炭吸附的该化学参数的千克数。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '82',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '过滤介质容量控制是关键。应保留废水中存在的可溶性和可吸附的苯酚作为参考。它应该在滤波器的输入和输出处定期进行测试。需要处理过的水流量数据。使用这些值，操作员应该知道以下两者之间的关系：过滤器中颗粒活性炭对特定化学参数的吸附能力，单位是每千克活性炭吸附的该化学参数的千克数。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['苯酚']
  },
  {
    index: '83',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '过滤介质容量控制是关键。废水中存在的一些化学特性参数应保留为参考。并且应该在滤波器的输入和输出端定期进行测试。需要处理过的水流量数据。使用这些值，操作员应该知道以下两者之间的关系：过滤器中颗粒活性炭对特定化学参数的吸附能力，单位是每千克活性炭吸附的该化学参数的千克数。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: [
      '钴',
      '锌',
      '砷',
      '铜',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '镍',
      '银',
      '汞',
      '总悬浮物',
      '六价铬',
      '全价铬',
      '铅',
      '镉'
    ]
  },
  {
    index: '84',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '应控制过滤介质的持续时间。对于高强度使用：预计砂滤介质可以持续使用 2 至 3 年。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: [
      '钴',
      '锌',
      '砷',
      '铜',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '总氮',
      '全价铬',
      '化学需氧量',
      '镍',
      '银',
      '总磷',
      '总悬浮物',
      '六价铬',
      '汞',
      '5日生化需氧量',
      '铅',
      '镉'
    ]
  },
  {
    index: '85',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '过滤速度建议:10 ~ 15m3 /h/m2',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: [
      '铜',
      '总氮',
      '苯酚',
      '镉',
      '钴',
      '可吸收有机卤素',
      '化学需氧量',
      '银',
      '总磷',
      '汞',
      '全价铬',
      '5日生化需氧量',
      '铅',
      '锌',
      '砷',
      '总悬浮物',
      '六价铬',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '镍'
    ]
  },
  {
    index: '86',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '过滤速度建议:12 ~ 18m3 /h/m2',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: [
      '钴',
      '锌',
      '砷',
      '铜',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '总氮',
      '全价铬',
      '化学需氧量',
      '镍',
      '银',
      '总磷',
      '总悬浮物',
      '六价铬',
      '汞',
      '5日生化需氧量',
      '铅',
      '镉'
    ]
  },
  {
    index: '87',
    typeId: 'wastewater',
    category: ['活性炭过滤器', '砂滤池'],
    text: '细小的沉淀硫化物粉末会污染沙粒，应避免在过滤器输入处使用。为此，应正确操作先前的处理操作（参见第 3 单元：凝结，第 4 单元：絮凝，第 5 单元：沉降）。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['硫化物']
  },
  {
    index: '88',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '建议使用泡沫抑制器。硅基消泡剂与过滤合成膜不相容。替代品:基于醚和有机酸盐的混合物以及烷基烃中的脂肪酸盐的商业产品。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['持久性泡沫']
  },
  {
    index: '89',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: 'For 5日生化需氧量 due to solid particles: Camp number recommended 20.000-50.000 u. Note: Camp number (Gt) is the product resulting from the velocity gradient (G, s-1) by the hydraulic retention time (HRT).  This parameter is widely used in designing rapid mixing and flocculation processes. Accurate Camp number must be obtained by jar test experiments.',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '90',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '对于固体颗粒产生的生化需氧量:水力负荷应小于净沉降面积1-2 m3/h/m2',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '91',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '对于固体颗粒造成的生化需氧量:水力保留时间(HRT)应> 1小时，建议为2至4小时。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '92',
    typeId: 'wastewater',
    category: ['凝结', '絮凝'],
    text: '对于固体颗粒产生的生化需氧量:必须避免液压短路,反应器入口必须远离反应器出口，并且必须保证混合',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '93',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '对于固体颗粒产生的生化需氧量:必须避免液压短路,反应器入口必须远离反应器出口。需要合理的污泥入口和污泥扩散。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '94',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '对于固体颗粒产生的生化需氧量：净沉降面积的质量负荷应小于3kg /h/m2',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '95',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '对于固体颗粒产生的生化需氧量:必须剧烈搅拌。建议:速度梯度> 100s -1，转速> 100。反应池必须充分混合，无死体积。混合泵送> 100罐容积/h。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '96',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '对于固体颗粒产生的生化需氧量:混合必须温和。建议:速度梯度< 50s -1，转速< 50。反应池必须充分混合，无死体积。混合泵送> 20罐容积/h。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '97',
    typeId: 'wastewater',
    category: ['沉淀池', '絮凝'],
    text: '对于固体颗粒产生的生化需氧量:污泥体积指数(SVI)应<= 150 ml/g。SVI用于描述活性污泥法曝气池中污泥的沉降特性。定义为1克活性污泥沉淀30分钟后所占体积(mL)。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '98',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '对于由于固体颗粒产生的生化需氧量:建议正确沉降的温度低于30℃。因此，必须检查温度是否正确。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '99',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '对于固体颗粒产生的生化需氧量:堰速应< 4 m3/h/m',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '100',
    typeId: 'wastewater',
    category: ['凝结', '收集池'],
    text: '对于固体颗粒产生的生化需氧量:建议在30℃以下进行化学混凝和絮凝工艺。因此，必须检查水在进入混凝反应器(收集池)之前的温度小于30℃。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '101',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '对于固体颗粒产生的生化需氧量:污泥提取流量应保证污泥高度低于清水表面1 ~ 2m',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '102',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '由于固体颗粒的化学需氧量。沉降过程建议在10ºC以上操作，因为粘度增加会导致骨料向下的速度降低。因此，必须检查水温是否在10℃以上',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '103',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '对于固体颗粒造成的化学需氧量: Camp数推荐为20000 - 50000 u。注:Camp数(Gt)是速度梯度(G, s-1)与水力停留时间(HRT)的乘积。该参数广泛用于设计快速混合和絮凝工艺。准确的Camp数必须通过罐试实验得到。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '104',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '固体颗粒化学需氧量:水力负荷应小于净沉降面积1-2 m3/h/m2',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '105',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '对于固体颗粒造成的化学需氧量:水力停留时间(HRT)应> 1小时，建议为2至4小时。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '106',
    typeId: 'wastewater',
    category: ['凝结', '絮凝'],
    text: '对于固体颗粒引起的化学需氧量:必须避免液压短路，反应器入口必须远离反应器出口，必须保证混合',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '107',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '对于固体颗粒引起的化学需氧量:必须避免液压短路,反应器入口必须远离反应器出口。需要合理的污泥入口和污泥扩散。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '108',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '固体颗粒化学需氧量:质量负荷应小于3kg /h/m2净沉降面积',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '109',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '由于固体颗粒的化学需氧量:混合必须是强烈的。建议:速度梯度> 100s -1，转速> 100。反应池必须充分混合，无死水。混合泵送> 100罐容积/h。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '110',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '由于固体颗粒的化学需氧量:混合必须温和。建议:速度梯度< 50s -1，转速< 50。反应池必须充分混合，无死体积。混合泵送> 20罐容积/h。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '111',
    typeId: 'wastewater',
    category: ['沉淀池', '絮凝'],
    text: '对于固体颗粒引起的化学需氧量:污泥体积指数(SVI)应<= 150 ml/g。SVI用于描述活性污泥法曝气池中污泥的沉降特性。定义为1克活性污泥沉淀30分钟后所占体积(mL)。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '112',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '对于固体颗粒导致的化学需氧量:建议正确沉降的温度低于30℃。因此，必须检查温度是否正确。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '113',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '固体颗粒化学需氧量:堰速应< 4 m3/h/m',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '114',
    typeId: 'wastewater',
    category: ['凝结', '絮凝'],
    text: '对于固体颗粒产生的化学需氧量:建议在30℃以下进行化学混凝和絮凝处理。因此，必须检查水在进入混凝反应器(收集池)之前的温度小于30℃。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '115',
    typeId: 'wastewater',
    category: ['收集池'],
    text: '对于固体颗粒产生的化学需氧量:建议在30℃以下进行化学混凝和絮凝处理。因此，必须检查水在进入混凝反应器(收集池)之前的温度小于30℃。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '116',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '对于固体颗粒产生的化学需氧量:污泥提取流程应保证污泥高度低于清水表面1 ~ 2m',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '117',
    typeId: 'wastewater',
    category: ['格栅'],
    text: '对于附着在团块上的大肠菌群，精细筛选是有用的。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['大肠杆菌群 [细菌数/100毫升]']
  },
  {
    index: '118',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '对于含有固体颗粒的油和油脂:必须剧烈搅拌。建议:速度梯度> 100s -1，转速> 100。反应池必须充分混合，无死体积。混合泵送> 100罐容积/h。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['油和油脂']
  },
  {
    index: '119',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '对于含有固体颗粒的油和润滑脂:建议正确沉降的温度低于30℃。因此，必须检查温度是否正确。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['油和油脂']
  },
  {
    index: '120',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '对于全氮接触时间应足够(HRT) > 15 min',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '121',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '固体颗粒导致的总氮:Camp数推荐为20000 - 50000 u。注:Camp数(Gt)是速度梯度(G, s-1)与水力停留时间(HRT)的乘积。该参数广泛用于设计快速混合和絮凝工艺。准确的Camp数必须通过罐试实验得到。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '122',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '固体颗粒总氮:水力负荷应小于净沉降面积1-2 m3/h/m2',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '123',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '对于固体颗粒引起的总氮:水力保留时间(HRT)应> 1小时，建议为2 - 4小时。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '124',
    typeId: 'wastewater',
    category: ['凝结', '絮凝'],
    text: '对于固体颗粒引起的总氮:必须避免水力短路，反应器入口必须远离反应器出口，并保证混合充分',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '125',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '对于固体颗粒引起的总氮:必须避免水力短路,反应器入口必须远离反应器出口。需要合理的污泥入口和污泥扩散。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '126',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '固体颗粒总氮:净沉降面积的质量负荷应小于3kg /h/m2',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '127',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '由于固体颗粒引起的总氮:必须强烈搅拌。建议速度梯度> 100s -1, rpm > 100。反应池必须充分混合，无死体积。混合泵送> 100罐容积/h。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '128',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '由于固体颗粒引起的全氮:混合必须温和。建议:速度梯度< 50s -1，转速< 50。反应池必须充分混合，无死体积。混合泵送> 20罐容积/h。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '129',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '由于固体颗粒导致的总氮:沉降过程建议在10℃以上进行，因为粘度的增加会导致团聚体向下的速度降低。因此，必须检查水温是否在10℃以上。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '130',
    typeId: 'wastewater',
    category: ['沉淀池', '絮凝'],
    text: '对于固体颗粒引起的总氮:污泥体积指数(SVI)应<= 150 ml/g。SVI用于描述活性污泥法曝气池中污泥的沉降特性。定义为1克活性污泥沉淀30分钟后所占体积(mL)。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '131',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '由于固体颗粒导致的总氮:建议正确沉降的温度低于30℃。因此，必须检查温度是否正确。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '132',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '固体颗粒总氮:堰速应< 4 m3/h/m',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '133',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '对于固体颗粒产生的总氮:污泥提取流程应保证污泥高度低于清水表面1 ~ 2m',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '134',
    typeId: 'wastewater',
    category: ['凝结', '絮凝'],
    text: '对于固体颗粒产生的总氮:建议在30℃以下进行化学混凝和絮凝处理。因此，必须检查水在进入混凝反应器(收集池)之前的温度小于30℃。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '135',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '对于高生化需氧量消减率，需要低F/M设计值。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '136',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '对于高浓度，建议在混凝操作之前使用粉末形式的活性炭。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: [
      '钴',
      '锌',
      '砷',
      '铜',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '总氮',
      '全价铬',
      '化学需氧量',
      '镍',
      '银',
      '总磷',
      '六价铬',
      '汞',
      '5日生化需氧量',
      '铅',
      '苯酚',
      '镉'
    ]
  },
  {
    index: '137',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '对于凝结的非可溶性染料，建议使用高强度的絮凝剂',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['顏色  [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '138',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '对于不溶性染料，建议使用基于铝形式的混凝剂，如聚氯化铝，因为氢氧铝的吸附能力强',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['顏色  [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '139',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '对于正磷酸盐的去除，部分磷会融入新的生物污泥中，但化学控制可以有所帮助。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总磷']
  },
  {
    index: '140',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '对于固体颗粒形成的正磷酸盐:水力负荷应小于净沉降面积1-2 m3/h/m2',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '141',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '由于固体颗粒导致的正磷酸盐:水力保留时间(HRT)应> 1小时，建议为2至4小时。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '142',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '对于固体颗粒引起的正磷酸盐:必须避免水力短路,反应器入口必须远离反应器出口。需要合理的污泥入口和污泥扩散。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '143',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '对于固体颗粒形成的正磷酸盐:净沉降面积的质量负荷应小于3kg /h/m2',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '144',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '对于含有固体颗粒的正磷酸盐:建议正确沉降的温度低于30℃。因此，必须检查温度是否正确。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '145',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '对于固体颗粒形成的正磷酸盐:堰速应< 4 m3/h/m',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '146',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '对于固体颗粒形成的正磷酸盐:污泥提取流程应保证污泥高度低于清水表面1 ~ 2m',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '147',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '对于正磷酸盐沉淀，建议在剂量点有很高的混合强度(G值在200和300秒‐1之间)。高能混合时间一般在10 ~ 30秒。在此混合操作后，应应用电流混凝。反应池必须充分混合，无死水。混合泵送> 100罐容积/h。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '148',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '对于正磷酸盐沉淀:Camp数推荐为20.000-50.000 u。注:Camp数(Gt)是速度梯度(G, s-1)与水力停留时间(HRT)的乘积。该参数广泛用于设计快速混合和絮凝工艺。准确的Camp数必须通过罐试实验得到。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '149',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '对于正磷酸盐沉淀:必须避免水力短路,反应器入口必须远离反应器出口，并且必须保证混合',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '150',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '对于正磷酸盐沉淀:混合必须温和。建议:速度梯度< 50s -1，转速< 50。反应池必须充分混合，无死水。混合泵送> 20罐容积/h。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '151',
    typeId: 'wastewater',
    category: ['沉淀池', '絮凝'],
    text: '对于正磷酸盐沉淀:污泥体积指数(SVI)应<= 150ml /g。SVI用于描述活性污泥法曝气池中污泥的沉降特性。定义为1克活性污泥沉淀30分钟后所占体积(mL)。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '152',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '对于含有固体颗粒的磷酸磷:必须避免液压短路,反应器入口必须远离反应器出口，并且必须保证混合',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '153',
    typeId: 'wastewater',
    category: ['收集池'],
    text: '对于固体颗粒产生的总氮:建议在30℃以下进行化学混凝和絮凝处理。因此，必须检查水在进入混凝反应器(收集池)之前的温度小于30℃。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '154',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '对于固体颗粒产生的总磷:建议在30℃以下进行化学混凝和絮凝处理。因此，必须检查水在进入混凝反应器(收集池)之前的温度小于30℃。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '155',
    typeId: 'wastewater',
    category: ['收集池'],
    text: '对于固体颗粒产生的总磷:建议在30℃以下进行化学混凝和絮凝处理。因此，必须检查水在进入混凝反应器(收集池)之前的温度小于30℃。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '156',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '应根据过滤器制造商的建议选择颗粒尺寸、孔径和碳类型。检查你的水的成分是否已经改变，你是否需要改变碳的类型或颗粒大小。请记住，极性和低分子量的物质很少保留在活性炭孔上。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['顏色  [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '157',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '卤化可溶性物质目前以低浓度吸附在活性炭上。对于高浓度，建议在凝结物反应之前使用粉末形式的活性炭',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['可吸收有机卤素']
  },
  {
    index: '158',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '微量重金属可以被活性炭颗粒吸收。建议使用矿物活性炭。这应该被认为是活性炭使用的一个附带功能，而不是真正的处理途径。离子不适合碳吸附。酸性介质提高了吸附性(pH值从4到6)。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: [
      '钴',
      '锌',
      '砷',
      '铜',
      '锑',
      '镍',
      '银',
      '汞',
      '六价铬',
      '全价铬',
      '铅',
      '镉'
    ]
  },
  {
    index: '159',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '高电导率/盐度会降低活性污泥的性能，因此会影响五日生化需氧量的性能。为了获得正确的性能，反应器输入处的氯化物应小于10.000 ppm，硫酸盐应小于1.000 ppm',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '160',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '高电导率/盐分会降低活性污泥的性能，因此会影响化学需氧量性能。为了获得正确的性能，反应器输入处的氯化物应<10.000 ppm，硫酸盐应< 1.000 ppm',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量']
  },
  {
    index: '161',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '高电导率/盐分会降低活性污泥的性能，因此会影响总磷的性能。为了获得正确的性能，反应器输入处的氯化物应<10.000 ppm，硫酸盐应< 1.000 ppm',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总磷']
  },
  {
    index: '162',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '高电导率/盐分会降低活性污泥的性能，因此会影响总氮性能。为了获得正确的性能，反应器输入处的氯化物应<10.000 ppm，硫酸盐应< 1.000 ppm',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总氮']
  },
  {
    index: '163',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '高分子量化学物质比低分子量物质更好地保留。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['化学需氧量', '5日生化需氧量']
  },
  {
    index: '164',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '高分子量氮化合物比低分子量物质更容易被保留。氨等低分子量物质不会吸附在活性碳纤维上。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '165',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '高分子量磷化合物比低分子量物质更容易被保留。低分子量物质，如邻苯二甲酸酯，不会吸附在活性炭纤维上。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '166',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '超过25ºC的高温将恶化活性污泥的沉降，并会促进非沉降细菌（例如丝片状诺卡氏菌）。所以，必须检查水温是否正确。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量', '温度']
  },
  {
    index: '167',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '超过25ºC的高温将恶化活性污泥的沉降，并会促进非沉降细菌（例如丝片状诺卡氏菌）。因此，为了避免总悬浮固体损失和沉降器排放(因此五日生化需氧量不符合要求)，必须检查水温是否正确。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '168',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '高于25°C的高温会恶化活性污泥的沉降，并会促进不沉降的细菌，如丝状诺卡氏菌。因此，为了避免总悬浮固体损失和沉降器排放(因此总氮不符合要求)，必须检查水温是否正确。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总氮']
  },
  {
    index: '169',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '高于25°C的高温会恶化活性污泥的沉降，并会促进不沉降的细菌，如丝状诺卡氏菌。因此，为了避免总悬浮固体损失和沉降器排放(以及总磷不合规)，必须检查水温是否正确。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总磷']
  },
  {
    index: '170',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '高于25°C的高温会恶化活性污泥的沉降，并会促进不沉降的细菌，如丝状诺卡氏菌。因此，为了避免沉降器排放时总悬浮固体损失，必须检查水温是否正确。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总悬浮物']
  },
  {
    index: '171',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '水力负荷应小于1-2 m3/h/m2的净沉淀面积',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '锌',
      '硫化物',
      '砷',
      '铜',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '油和油脂',
      '镍',
      '银',
      '汞',
      '总悬浮物',
      '六价铬',
      '全价铬',
      '铅',
      '镉'
    ]
  },
  {
    index: '172',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '水力停留时间（HRT）应> 1小时。建议2至4小时。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '锌',
      '硫化物',
      '砷',
      '铜',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '油和油脂',
      '镍',
      '银',
      '汞',
      '总悬浮物',
      '六价铬',
      '全价铬',
      '铅',
      '镉'
    ]
  },
  {
    index: '173',
    typeId: 'wastewater',
    category: ['凝结', '絮凝', '收集池'],
    text: '必须避免水力短路：反应器入口必须远离反应器出口，必须保证混合',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '铜',
      '总氮',
      '镉',
      '钴',
      '油和油脂',
      '化学需氧量',
      '银',
      '总磷',
      '汞',
      '全价铬',
      '5日生化需氧量',
      '铅',
      '锌',
      '砷',
      'PH值',
      '总悬浮物',
      '六价铬',
      '硫化物',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '镍'
    ]
  },
  {
    index: '174',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '必须避免水力短路：反应器入口必须远离反应器出口。需要合理的污泥入口和污泥散布。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '锌',
      '硫化物',
      '砷',
      '铜',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '油和油脂',
      '镍',
      '银',
      '汞',
      '总悬浮物',
      '六价铬',
      '全价铬',
      '铅',
      '镉'
    ]
  },
  {
    index: '175',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '如果电导率上升，可以研究用于PH值调节的替代试剂。高电导率/盐分会降低活性污泥的性能。为了获得正确的性能，反应器输入处的氯化物应<10.000 ppm，硫酸盐应< 1.000 ppm。此外，突然的电导率变化会导致反应堆受到影响。均匀化和浓度平衡是反应器性能正确的基础。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['电导率']
  },
  {
    index: '176',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '如果电导率上升，可以研究用于pH值调节的替代试剂。高电导率/盐度会降低活性污泥的性能。为了获得正确的性能，反应器输入处的氯化物应小于10.000 ppm，硫酸盐应小于1.000 ppm。此外，电导率的突然变化会影响反应器/二次沉淀。均匀化和浓度平衡是正确的反应器和二次沉淀性能的基础。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['电导率']
  },
  {
    index: '177',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '如果金属难以沉淀，则必须使用特殊的有机硫化合物作为沉淀促进剂',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '锌',
      '砷',
      '锑',
      '镍',
      '银',
      '汞',
      '六价铬',
      '全价铬',
      '铅',
      '镉'
    ]
  },
  {
    index: '178',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '如果pH值升高/降低，可以研究用于pH值调节的替代试剂。生物反应器中pH值过低或过高都会导致污泥沉降速度和质量失调。正确的范围是从7，2到8，2。低pH值需要添加碱性试剂（例如烧碱），但高pH值需要添加酸性试剂（例如硫酸或氢氯酸）',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['PH值']
  },
  {
    index: '179',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '如果pH值升高/降低，可以研究用于pH值调节的替代试剂。生物反应器中的pH范围需要7.2至8.2的值。通常需要进行pH值修正。低pH值需要添加碱性试剂（例如烧碱），但高pH值需要添加酸性试剂（例如硫酸或氢氯酸）',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['PH值']
  },
  {
    index: '180',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '如果污泥没有很好地倾析，它会在澄清过程中产生总悬浮固体，从而导致化学需氧量不符合要求。为了避免化学需氧量不符合要求，必须对过程进行严格控制，特别是V30和SVI反应器控制。此外，化学需氧量抑制剂会导致沉降器性能严重失调。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量']
  },
  {
    index: '181',
    typeId: 'wastewater',
    category: ['收集池'],
    text: '在pH值可变的情况下，建议使用pH值探针，pH值用于PID。如果pH值升高，必须使用酸性试剂，如果pH值降低，必须使用碱性试剂',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['PH值']
  },
  {
    index: '182',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '必须检查温度是否正确。生物反应器中当前的工艺温度范围为16至22ºC，建议范围为18至20ºC。低于16ºC的低温将显着减慢生物过程，因此在进入生物反应器之前需要使用热交换器或热泵来加热废物。另一方面，温度>25至30ºC会影响硝酸化，并且>30-35ºC的硝酸化是不可行的。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['温度']
  },
  {
    index: '183',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '通过添加碳酸钠，铅可以在pH值为9.0 - 9.5时以碳酸盐的形式沉淀。另一种替代方案是用pH 11.5的石灰进行沉淀。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['铅']
  },
  {
    index: '184',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '铅不能复合。这意味着它们无法形成复合体。金属配合物是一种化合物，其中一个或多个金属原子与一个或多个配体键合。配体是能够通过一个或多个原子结合到金属中心的有机化合物。因此，金属必须是游离的，以便通过物理化学处理将其去除。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['铅']
  },
  {
    index: '185',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '浓度> 1.0至5 ppm的铅对活性污泥具有生物毒性，应在反应器输入处避免使用。预计不会接受治疗。 应避免在活性污泥中积聚。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['铅']
  },
  {
    index: '186',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '来自污泥或经处理的污水的总悬浮固体的损失将增加排放时的总磷值。所以，污水的固体控制是资本。为了避免由于固体泄漏而导致总磷不符合，必须对过程进行严密控制，特别是对V30´和SVI指数反应器进行控制',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总磷']
  },
  {
    index: '187',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '来自污泥或处理过的污水的总悬浮固体损失会增加排放时的总氮值。为了避免总氮不合规，必须严格控制过程，特别是V30和SVI反应器控制',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总氮']
  },
  {
    index: '188',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '来自污泥或处理过的污水的总悬浮固体损失将增加排放时的五日生化需氧量。为了避免不符合五日生化需氧量，必须严格控制过程，特别是V30和SVI反应器控制',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '189',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '来自污泥或处理过的污水的总悬浮固体损失将增加排放的化学需氧量值。因此，流出物中的固体控制是关键(V30测量值和SVI值应保持在<150毫升/克)。为了了解化学需氧量不符合性是否是由于固体泄漏造成的，应在二级滗析器出口水中分析总悬浮固体，然后应用以下表达式:由总悬浮固体造成的理论化学需氧量等于1,46x 总悬浮固体结果(ppm)。因此，二级滗析器出口水中的实际化学需氧量(如果没有固体泄漏= 化学需氧量 (ppm)结果-理论上由于总悬浮固体导致的化学需氧量',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量']
  },
  {
    index: '190',
    typeId: 'wastewater',
    category: ['格栅'],
    text: '建议在通道中采用低混合气液能量',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['持久性泡沫']
  },
  {
    index: '191',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '由于粘性增加，低温会稍微降低过滤速度。相反，高温会提高过滤速度。过滤器容量应根据偶然出现的极低或极高的温度来设计。 对于当前温度范围（10至30ºC），预计不会产生任何影响。因此，必须检查水温是否正确。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['全价铬', '砷']
  },
  {
    index: '192',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '由于粘性增加，低温会稍微降低过滤速度。相反，高温会提高过滤速度。过滤器容量应根据偶然出现的极低或极高的温度来设计。 对于当前温度范围（10至30ºC），预计不会产生任何影响。因此，必须检查水温是否正确。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: [
      '钴',
      '锌',
      '铜',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '总氮',
      '化学需氧量',
      '镍',
      '银',
      '总磷',
      '六价铬',
      '汞',
      '5日生化需氧量',
      '铅',
      '镉'
    ]
  },
  {
    index: '193',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '由于粘性增加，低温会稍微降低过滤速度。相反，高温会提高过滤速度。过滤器容量应根据偶然出现的极低或极高的温度来设计。 对于当前温度范围（10至30ºC），预计不会产生任何影响。因此，必须检查水温是否正确。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['总悬浮物']
  },
  {
    index: '194',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '质量负荷应小于净沉降面积3公斤/小时/m2',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '锌',
      '硫化物',
      '砷',
      '铜',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '油和油脂',
      '镍',
      '银',
      '汞',
      '总悬浮物',
      '六价铬',
      '全价铬',
      '铅',
      '镉'
    ]
  },
  {
    index: '195',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '使用有机硫化物沉淀或氢氧化铁共沉淀来沉淀汞1+。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['汞']
  },
  {
    index: '196',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '汞不能络合。这意味着它们不能形成复合物。金属络合物是一种化合物，其中一个或多个金属原子键合到一个或多个配体上。配体是能够通过一个或多个原子与金属中心结合的有机化合物。因此，金属必须是游离的，这样才能通过物理化学处理去除。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['汞']
  },
  {
    index: '197',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '汞在浓度> 0.1至1ppm时对活性污泥具有生物毒性，应避免在沉降器输入处使用。预计没有治疗。应避免在活性污泥中积累。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['汞']
  },
  {
    index: '198',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '通过沉淀分离的汞必须处于氧化态1+。金属形态对沉淀不敏感。在这种情况下，需要使用过氧化氢在pH值为9的碱性介质中进行氧化。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['汞']
  },
  {
    index: '199',
    typeId: 'wastewater',
    category: ['收集池'],
    text: '混合有助于利用每小时的废水流量进行中和。建议混合能量密度> 35 W/m3',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['PH值']
  },
  {
    index: '200',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '混合一定要强烈。建议:速度梯度> 100s -1，转速> 100。反应池必须充分混合，无死水。混合泵送> 100罐容积/h。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['硫化物', '总悬浮物']
  },
  {
    index: '201',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '混合一定要强烈。建议:速度梯度> 100s -1，转速> 100。反应池必须充分混合，无死水。混合泵> 20。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['顏色  [m-1] (436 nm; 525 nm; 620 nm)', 'PH值']
  },
  {
    index: '202',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '混合一定要温和。建议:速度梯度< 50s -1，转速< 50。反应池必须充分混合，无死水。混合泵送> 20罐容积/h',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['顏色  [m-1] (436 nm; 525 nm; 620 nm)', '总悬浮物', '硫化物']
  },
  {
    index: '203',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '混合一定要温和。建议:速度梯度< 50s -1，转速< 50。反应池必须充分混合，无死水。混合泵送> 20罐容积/h。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '锌',
      '砷',
      '铜',
      '锑',
      '油和油脂',
      '镍',
      '银',
      '汞',
      '六价铬',
      '全价铬',
      '铅',
      '镉'
    ]
  },
  {
    index: '204',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '中和剂必须小心地加量，特别是对低碱度废水。在这种情况下，可以使用柔软或温和的中和剂。如:CO&#8322;作为酸化剂/Ca(OH)&#8322;或Na&#8322;CO&#8323;',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['PH值']
  },
  {
    index: '205',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '使用石灰可以将镍作为氢氧化物沉淀至pH 10 - 11。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['镍']
  },
  {
    index: '206',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '镍不能络合。这意味着它们不能形成复合物。金属配合物是一种化合物，其中一个或多个金属原子与一个或多个配体结合。配体是一种能够通过一个或多个原子与金属中心结合的有机化合物。因此，金属必须是游离的，以便通过物理化学处理将其除去。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['镍']
  },
  {
    index: '207',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '浓度> 1.0至2.5 ppm的镍对活性污泥具有生物毒性，应在反应器输入处避免使用。预计不会接受治疗。 应避免在活性污泥中积聚。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['镍']
  },
  {
    index: '208',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '硝酸化需要相对较高的污泥龄（> 15天，具体取决于反应器温度范围）和反应器温度在>15ºC和<25ºC之间。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总氮']
  },
  {
    index: '209',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '氮非极性和高分子量化合物(如三嗪)预计会保留在活性炭孔上。商品活性炭中的孔径分布，应根据要保留的化合物特性来选择。相反，极性和低分子量物质(如氨)很少保留在活性炭孔上。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '210',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '预计不会采取任何行动（油和油脂不可溶且不可生物降解）。应在反应器入口处避免这种情况。油和油脂不可生物降解，因为它们不可溶，并且可能是活性污泥严重失调的原因，例如氧气传递不良和存在非沉降细菌（例如菌丝）。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['油和油脂']
  },
  {
    index: '211',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '预计不会采取任何行动（苯酚具有生物毒性，应避免在生物反应器输入处使用）。观察到抑制水平为50至200 ppm。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['苯酚']
  },
  {
    index: '212',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '预计不会采取任何措施降低/升高该装置的温度。然而：活性炭的容量随着温度的升高而降低。对于非常高的温度，预计吸收能力会下降。对于当前温度范围（10至30ºC），预计不会产生任何影响。 因此，必须检查水温是否正确。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['温度']
  },
  {
    index: '213',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '预计不会采取任何措施降低/升高该装置的温度。然而：低温会稍微降低过滤速度，因为粘性增加。相反，高温会提高过滤速度。过滤器容量应根据偶然出现的极低或极高的温度来设计。 对于当前温度范围（10至30ºC），预计不会产生任何影响。因此，必须检查水温是否正确。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['温度']
  },
  {
    index: '214',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '预计不会采取任何措施降低/升高该装置的温度。然而：建议沉积过程在10ºC以上进行，因为粘性增加会导致聚集体向下速度下降。 因此，必须检查水温是否在10ºC以上。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['温度']
  },
  {
    index: '215',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '预计不会采取任何措施降低/升高该装置的温度。然而：化学混凝和混凝过程建议在30ºC以下运行，因此，在进入混凝反应器（收集罐中）之前必须检查水温是否低于30ºC',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['温度']
  },
  {
    index: '216',
    typeId: 'wastewater',
    category: ['凝结', '收集池'],
    text: '预计不会采取任何措施降低/升高该装置的温度。然而：化学混凝和混凝过程建议在30ºC以下运行，因此，在进入混凝反应器（收集罐中）之前必须检查水温是否低于30ºC。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['温度']
  },
  {
    index: '217',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '预计不会采取任何行动。 浓度> 1 ppm的铬6+对活性污泥具有生物毒性，应在反应器输入处避免使用。 应避免在活性污泥中积聚。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['六价铬']
  },
  {
    index: '218',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '预计不会采取任何行动。锑对活性污泥具有生物毒性，应避免在反应器输入处使用。 应避免在活性污泥中积聚。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['锑']
  },
  {
    index: '219',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '预计不会采取任何行动。砷对浓度> 0.1 ppm的活性污泥具有生物毒性，应在反应器输入处避免使用。 应避免在活性污泥中积聚。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['砷']
  },
  {
    index: '220',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '预计不会采取任何行动。浓度> 1至10 ppm的镉对活性污泥具有生物毒性，应在反应器输入处避免使用。 应避免在活性污泥中积聚。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['镉']
  },
  {
    index: '221',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '预计不会采取任何行动。钴对活性污泥具有生物毒性，应在反应器输入处避免使用。 应避免在活性污泥中积聚。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['钴']
  },
  {
    index: '222',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '预计不会采取任何行动。大肠菌群在充气反应器中被降低，但不会被消除或控制。无论如何，曝气生物处理不是大肠菌群处理程序。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['大肠杆菌群 [细菌数/100毫升]']
  },
  {
    index: '223',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '预计不会采取任何行动。浓度> 1，0 ppm的铜对活性污泥具有生物毒性，应在反应器输入处避免使用。 应避免在活性污泥中积聚。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['铜']
  },
  {
    index: '224',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '预计不会采取任何行动。氯化物具有生物毒性，应避免在反应堆输入处使用。氯化物抑制水平30 ppm。应避免在活性污泥中积聚。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['氰化物总量']
  },
  {
    index: '225',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '预计不会采取任何行动。氰化钠会导致活性污泥的反凝聚和沉降不良。应避免生物反应器输入处出现氰化钠。 应避免在活性污泥中积聚。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['氰化物总量']
  },
  {
    index: '226',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '预计不会采取任何行动。应避免在反应器和二次沉淀输入处发生这种情况。油脂会降低污泥密度，严重损害污泥沉降质量。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['油和油脂']
  },
  {
    index: '227',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '预计不会采取任何行动。浓度> 1.0至5 ppm的铅对活性污泥具有生物毒性，应在反应器输入处避免使用。 应避免在活性污泥中积聚。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['铅']
  },
  {
    index: '228',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '预计不会采取任何行动。浓度> 0.1至1 ppm的汞对活性污泥具有生物毒性，应在反应器输入处避免使用。 应避免在活性污泥中积聚。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['汞']
  },
  {
    index: '229',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '预计不会采取任何行动。浓度> 1.0至2.5 ppm的镍对活性污泥具有生物毒性，应在反应器输入处避免使用。 应避免在活性污泥中积聚。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['镍']
  },
  {
    index: '230',
    typeId: 'wastewater',
    category: ['活性炭过滤器', '砂滤池'],
    text: '预计不会采取任何行动。不可溶性或油性物质会严重污染过滤媒体。应避免过滤器输入处的这些物质。为此，应正确操作之前的治疗操作。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['油和油脂']
  },
  {
    index: '231',
    typeId: 'wastewater',
    category: ['收集池'],
    text: '预计不会采取任何行动。不建议油和油脂进入收集罐。最好在均质化之前进行分离。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['油和油脂']
  },
  {
    index: '232',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '预计不会采取任何行动。酚类物质可导致污水排放中的反絮凝和总悬浮物损失，影响化学需氧量/5日生化需氧量/氮/磷排放质量。应避免在生物反应器输入端使用',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['苯酚']
  },
  {
    index: '233',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '预计不会采取任何行动。银对活性污泥具有生物毒性，应避免在反应器输入端使用。应避免活性污泥中的积聚。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['银']
  },
  {
    index: '234',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '预计不会采取任何行动。当获得高质量沉降和排放废水的低浑浊度时，预期会减少一些大肠杆菌。无论如何，采用非大肠杆菌形式的处理程序。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['大肠杆菌群 [细菌数/100毫升]']
  },
  {
    index: '235',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '预计不会采取任何行动。硫化物会导致反絮凝和活性污泥沉降不良。应避免在生物反应器内投入硫化物。为此，应正确操作之前的处理过程。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['硫化物']
  },
  {
    index: '236',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '预计不会采取任何行动。总铬在浓度>1至100ppm时对活性污泥具有生物毒性，应避免在反应器输入端使用。应避免活性污泥中的积聚。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['全价铬']
  },
  {
    index: '237',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '预计不会采取任何行动。锌在浓度大于0.3至5ppm时对活性污泥具有生物毒性，应避免在反应器输入端使用。应避免活性污泥中的积聚。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['锌']
  },
  {
    index: '238',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '没有可生物降解的氮或缺乏硝化/反硝化技术会导致反应器和沉降器中的总氮浓度增加。另一方面，污泥或处理过的废水中总悬浮物的损失会增加排放时的氮值。因此，对废水进行固体控制是至关重要的（见总悬浮物参数的行动）。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总氮']
  },
  {
    index: '239',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '非极性和高分子量的化合物（如多环芳烃（PAHs），如苯并[a]芘）预计会保留在活性炭孔上。商用活性炭中的孔径分布，应根据要保留的化合物特性进行选择。相反，极性和低分子量物质（如甲醛）在活性炭孔上保留较弱。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '240',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '非极性和高分子量的化合物（如非极性长链脂质，如酰基甘油）预计会保留在活性炭孔上。商用活性炭中的孔径分布，应根据要保留的化合物特性进行选择。相反，极性和低分子量物质（如甲醇）在活性炭孔上保留较弱。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '241',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '非极性和高分子量的化合物（如对硫磷）预计会保留在活性炭孔上。商用活性炭中的孔径分布，应根据要保留的化合物特性进行选择。相反，极性和低分子量物质（如三氯化磷）在活性炭孔上保留较弱。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '242',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '由于过滤介质污染，必须避免活性炭过滤器输入端的不溶性5日生化需氧量。应排除污染的存在。如果过滤介质发生污染，该装置将无法正常工作，导致5日生化需氧量可能不合规。因此，之前的混凝+絮凝+砂滤装置应运行良好，以避免不溶性5日生化需氧量进入活性炭过滤器入口',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '243',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '如果粒径大于20-50微米，并且使用的粒径符合制造商的建议，则预计在砂滤过程中会保留不溶性5日生化需氧量。因此，必须检查以下内容：总5日生化需氧量和可溶性5日生化需氧量之间的关系，即使用的粒度。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '244',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '由于过滤介质污染，必须避免活性炭过滤器输入端的不溶性化学需氧量。应排除污染的存在。如果过滤介质发生污染，该装置将无法正常工作，导致化学需氧量可能不合规。因此，之前的混凝+絮凝+砂滤装置应运行良好，以避免不溶性化学需氧量进入活性炭过滤器入口',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '245',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '如果粒径大于20-50微米，并且使用的粒径符合制造商的建议，则预计在砂滤过程中会保留不溶性化学需氧量。因此，必须检查以下内容：总化学需氧量和可溶性化学需氧量之间的关系，使用的粒度。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '246',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '由于过滤介质污染，必须避免活性炭过滤器输入端的不溶性总氮。应排除污染的存在。如果过滤介质发生污染，该装置将无法正常工作，导致总氮可能不符合要求。因此，之前的混凝+絮凝+砂滤装置应运行良好，以避免不溶的总氮进入活性炭过滤器入口',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '247',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '如果粒径大于20-50微米，并且使用的粒径符合制造商的建议，则预计在砂滤过程中会保留不溶性总氮。因此，必须检查以下内容：总氮和可溶性氮之间的关系，使用的粒度。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '248',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '由于过滤介质污染，必须避免活性炭过滤器输入端的不溶性总磷。应排除污染的存在。如果过滤介质发生污染，该装置将无法正常工作，可能导致磷不合规。因此，之前的混凝+絮凝+砂滤装置应运行良好，以避免不溶性总磷进入活性炭过滤器入口',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '249',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '如果粒径大于20-50微米，并且使用的粒径符合制造商的建议，则预计在砂滤过程中会保留不溶性总磷。因此，必须检查以下内容：总磷和可溶性磷之间的关系以及使用的粒度。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '250',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '如果粒径大于20-50微米，并且使用的粒径符合制造商的建议，则预计在砂滤过程中会保留不溶性彩色染料。因此，必须检查以下内容：总彩色染料和可溶性彩色染料之间的关系，使用的粒度。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['顏色  [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '251',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '由于过滤介质污染，必须避免活性炭过滤器输入处的不溶性彩色染料。应排除污染的存在。如果过滤介质发生污染，该装置将无法正常工作，导致颜色参数可能不合规。因此，之前的混凝+絮凝+砂滤装置应运行良好，以避免不溶性有色染料进入活性炭过滤器入口',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['顏色  [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '252',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '不溶性或油性物质会导致过滤器容量损失，并严重污染过滤介质，因此应避免使用，以获得良好的性能。为此，请参阅油脂参数的作用。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: [
      '钴',
      '锌',
      '砷',
      '铜',
      '锑',
      '镍',
      '银',
      '汞',
      '六价铬',
      '全价铬',
      '铅',
      '镉'
    ]
  },
  {
    index: '253',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '不溶性或油性物质会严重污染过滤介质。为了避免它（如果它不能很好地工作，这可能会导致5日生化需氧量不合规），应避免过滤器输入处的这些物质。为此，应正确操作之前的处理流程。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['5日生化需氧量', '顏色  [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '254',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '不溶性或油性物质会严重污染过滤介质。为了避免它（如果它不能很好地工作，这可能会导致化学需氧量不合规），应避免在过滤器输入端使用这些物质。为此，应正确操作之前的处理流程。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '255',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '不溶性或油性物质会严重污染过滤介质。为了避免它（如果它不能很好地工作，这可能会导致总氮不合规），应避免过滤器输入处的这些物质。为此，应正确操作之前的处理流程。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '256',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '不溶性或油性物质会严重污染过滤介质。为了避免它（如果它不能很好地工作，这可能会导致总磷不合规），应避免过滤器输入处的这些物质。为此，应正确操作之前的处理流程。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['苯酚', '总磷']
  },
  {
    index: '257',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '5日生化需氧量不合规可能是由于水（无论是全部还是5日生化需氧量的一部分）没有生物降解或生物降解缓慢。可生物降解废水的化学需氧量/5日生化需氧量比值为2至3。如果比率较低，则考虑易生物降解的废水。如果该比率非常高（超过4），则会观察到废水的生物降解性较差。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '258',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '油和油脂痕迹可以在凝结前吸附在絮凝物上。优选使用聚合氯化铝等铝混凝剂源进行强混凝。铝混凝剂需要6.5至7.5 u的值',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['油和油脂']
  },
  {
    index: '259',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '油和油脂痕迹在凝结前吸附在絮体上时会絮凝。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['油和油脂']
  },
  {
    index: '260',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '含油废水会导致过滤器性能损失，为获得良好的性能应避免这种情况（如果性能不佳，可能会导致生化需氧量（5日生化需氧量）不达标）。为此，请参阅油脂参数的操作。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '261',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '含油废水会导致过滤器性能损失，为获得良好的性能应避免这种情况（如果性能不佳，可能会导致总磷不达标）。为此，请参阅油脂参数的操作。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '262',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '含油废水会导致过滤器性能损失，为获得良好的性能应避免这种情况（如果性能不佳，可能会导致化学需氧量不达标）。为此，请参阅油脂参数的操作。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '263',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '含油废水会导致过滤器性能损失，为获得良好的性能应避免这种情况（如果性能不佳，可能会导致总氮不达标）。为此，请参阅油脂参数的操作。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '264',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '含油废水会导致过滤器性能损失，为获得良好的性能应避免这种情况。为此，请参阅油脂参数的操作。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['顏色  [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '265',
    typeId: 'wastewater',
    category: ['格栅'],
    text: '只有在油脂结块较大的情况下，精细筛选才有用。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['油和油脂']
  },
  {
    index: '266',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '只有不溶性染料和着色剂可以通过化学凝聚分离。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['顏色  [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '267',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '只有真正的可生物降解（b化学需氧量）才能通过生物过程进行处理。污水处理厂排放物中不存在可生物降解的化学需氧量。不可生物降解部分（难降解化学需氧量）不能通过生物去除。处理说明：可生物降解废水的化学需氧量/5日生化需氧量比值通常为2至3。如果比率较低，则考虑易生物降解的废水。如果该比率非常高（超过4），预计废水的生物降解性较差。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量']
  },
  {
    index: '268',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '正磷酸盐可以通过以下方式沉淀：（a）基于表面络合模型Fe1.6（H2PO4）（OH）3.8/（b）当使用钙源如Ca（OH）2将pH值增加到10以上时，过量的钙离子将与磷酸盐反应，沉淀羟基磷灰石[Ca5(OH)(PO4)3]',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '269',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '建议使用PID，需要根据加药流量进行调整',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['PH值']
  },
  {
    index: '270',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '活性污泥法的曝气室内通常会增加持久性泡沫',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['持久性泡沫']
  },
  {
    index: '271',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '预计苯酚会吸附在活性炭上',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['苯酚']
  },
  {
    index: '272',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '压力砂滤器是总悬浮物控制的具体过程。过滤器输入端的总悬浮物浓度应<100-200ppm（<200-400NTU）。在这种情况下，必须提高之前工艺的混凝絮凝沉降性能。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['总悬浮物']
  },
  {
    index: '273',
    typeId: 'wastewater',
    category: ['收集池'],
    text: '使用化学加药在收集罐（7至8）中推荐的弱碱性酸碱度值（如果可能）',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['PH值']
  },
  {
    index: '274',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '将六价铬还原为三价，可以使用氢氧化钠作为试剂，在酸碱度值为 7.5时达到氢氧化物的最小溶解度。由于形成的沉淀物的再溶解，沉淀对酸碱度值敏感。当使用石灰时，在酸碱度值为8下操作时，共沉淀可以获得更好的结果，反应对酸碱度的依赖性较小。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['六价铬']
  },
  {
    index: '275',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '对于20-50微米的总悬浮物颗粒，砂过滤能力有限。因此，如果粒径较小，总悬浮物可能会出现不合规情况。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['总悬浮物']
  },
  {
    index: '276',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '建议在10ºC以上的环境中进行沉降过程，因为粘度的增加会导致聚集体向下速度的降低。否则，必须对水进行加热（例如使用热泵或热交换器）。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['汞']
  },
  {
    index: '277',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '建议在10ºC以上操作沉淀过程，因为粘度增加会导致聚集体向下速度降低。因此，必须检查水温是否高于10ºC',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['镍']
  },
  {
    index: '278',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '建议在10ºC以上操作沉淀过程，因为粘度增加会导致聚集体向下速度降低。因此，必须检查水温是否高于10ºC。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['5日生化需氧量', '镉']
  },
  {
    index: '279',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '建议在10ºC以上操作沉淀过程，因为粘度增加会导致聚集体向下速度降低。因此，必须检查水温是否高于10ºC。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '锌',
      '硫化物',
      '砷',
      '锑',
      '银',
      '总磷',
      '总悬浮物',
      '六价铬',
      '全价铬',
      '铅'
    ]
  },
  {
    index: '280',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '建议在10ºC以上操作沉淀过程，因为粘度增加会导致聚集体向下速度降低。因此，必须检查水温是否高于10ºC。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['顏色  [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '281',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '建议在10ºC以上操作沉淀过程，因为粘度增加会导致聚集体向下速度降低。因此，必须检查水温是否高于10ºC。否则，必须加热水（例如通过热泵或热交换器）',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['铜']
  },
  {
    index: '282',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '建议在10ºC以上操作沉淀过程，因为粘度增加会导致聚集体向下速度降低。因此，必须检查水温是否高于10ºC。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['油和油脂']
  },
  {
    index: '283',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '建议在10ºC以上进行沉淀过程，因为粘度增加会导致聚集体向下速度降低。因此，必须检查水温是否高于10ºC。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量']
  },
  {
    index: '284',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '建议在10ºC以上进行沉淀过程，因为粘度增加会导致聚集体向下速度降低。因此，必须检查水温是否高于10ºC。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['5日生化需氧量', '总氮', '总磷', '总悬浮物']
  },
  {
    index: '285',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '银可以用明矾或铁共沉淀。此外，银可以在酸碱值11下以氢氧化物的形式沉淀。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['银']
  },
  {
    index: '286',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '银不能络合。这意味着它们不能形成复合体。金属配合物是一种化合物，其中一个或多个金属原子与一个或多种配体结合。配体是一种能够通过一个或多个原子与金属中心结合的有机化合物。因此，金属必须是游离的，以便通过物理化学处理将其去除。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['银']
  },
  {
    index: '287',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '银对活性污泥具有生物毒性，应避免在反应器输入端使用。预计不会进行治疗。应避免活性污泥中的积聚。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['银']
  },
  {
    index: '288',
    typeId: 'wastewater',
    category: ['沉淀池', '絮凝'],
    text: '污泥体积指数（SVI）应<=150 ml/g。污泥体积指数用于描述活性污泥法中曝气池中污泥的沉降特性。它被定义为1克活性污泥在沉降30分钟后所占的体积（单位为毫升）。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '锌',
      '硫化物',
      '砷',
      '铜',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '油和油脂',
      '镍',
      '银',
      '汞',
      '总悬浮物',
      '六价铬',
      '全价铬',
      '铅',
      '镉'
    ]
  },
  {
    index: '289',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '污泥龄反应器的控制受到温度的显著影响。污泥浪费率应根据反应器温度（根据Arrhenius方程）进行调整',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量', '5日生化需氧量', '总氮', '总磷']
  },
  {
    index: '290',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '污泥提取流量应保证污泥水位低于清水表面1至2米',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '锌',
      '硫化物',
      '砷',
      '铜',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '油和油脂',
      '镍',
      '银',
      '汞',
      '总悬浮物',
      '六价铬',
      '全价铬',
      '铅',
      '镉'
    ]
  },
  {
    index: '291',
    typeId: 'wastewater',
    category: ['格栅'],
    text: '应分离大于1-3mm的固体颗粒，以避免锑来自固体',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['锑']
  },
  {
    index: '292',
    typeId: 'wastewater',
    category: ['格栅'],
    text: '应分离大于1-3mm的固体颗粒，以避免砷来自固体',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['砷']
  },
  {
    index: '293',
    typeId: 'wastewater',
    category: ['格栅'],
    text: '应分离大于1-3mm的固体颗粒，以避免5日生化需氧量来自固体',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '294',
    typeId: 'wastewater',
    category: ['格栅'],
    text: '应分离大于1-3mm的固体颗粒，以避免化学需氧量来自固体',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '295',
    typeId: 'wastewater',
    category: ['格栅'],
    text: '应分离大于1-3mm的固体颗粒，以避免镉来自固体',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['镉']
  },
  {
    index: '296',
    typeId: 'wastewater',
    category: ['格栅'],
    text: '应分离大于1-3mm的固体颗粒，以避免六价铬来自固体',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['六价铬']
  },
  {
    index: '297',
    typeId: 'wastewater',
    category: ['格栅'],
    text: '应分离大于1-3mm的固体颗粒，以避免钴来自固体',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['钴']
  },
  {
    index: '298',
    typeId: 'wastewater',
    category: ['格栅'],
    text: '应分离大于1-3mm的固体颗粒，以避免铜从固体中出来',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['铜']
  },
  {
    index: '299',
    typeId: 'wastewater',
    category: ['格栅'],
    text: '应分离大于1-3mm的固体颗粒，以避免铅来自固体',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['铅']
  },
  {
    index: '300',
    typeId: 'wastewater',
    category: ['格栅'],
    text: '应分离大于1-3mm的固体颗粒，以避免汞来自固体',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['汞']
  },
  {
    index: '301',
    typeId: 'wastewater',
    category: ['格栅'],
    text: '应分离大于1-3mm的固体颗粒，以避免镍来自固体',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['镍']
  },
  {
    index: '302',
    typeId: 'wastewater',
    category: ['格栅'],
    text: '应分离大于1-3mm的固体颗粒，以避免银来自固体',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['银']
  },
  {
    index: '303',
    typeId: 'wastewater',
    category: ['格栅'],
    text: '应分离大于1-3mm的固体颗粒，以避免固体中的硫化物',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['硫化物']
  },
  {
    index: '304',
    typeId: 'wastewater',
    category: ['格栅'],
    text: '应分离大于1-3mm的固体颗粒，以避免总氮来自固体',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总氮']
  },
  {
    index: '305',
    typeId: 'wastewater',
    category: ['格栅'],
    text: '应分离大于1-3mm的固体颗粒，以避免总磷来自固体',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['总磷']
  },
  {
    index: '306',
    typeId: 'wastewater',
    category: ['格栅'],
    text: '应分离大于1-3mm的固体颗粒，以避免锌来自固体',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['锌']
  },
  {
    index: '307',
    typeId: 'wastewater',
    category: ['收集池'],
    text: '必须避免储罐内分层。必须施加足够的混合能量以避免沉淀。建议混合能量密度>35 W/m3',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '铜',
      '总氮',
      '镉',
      '钴',
      '化学需氧量',
      '银',
      '总磷',
      '汞',
      '全价铬',
      '5日生化需氧量',
      '铅',
      '锌',
      '砷',
      '总悬浮物',
      '六价铬',
      '硫化物',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '镍'
    ]
  },
  {
    index: '308',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '电导率的突然变化会影响反应。均匀化和浓度平衡是反应器正确表现的体现',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量', '5日生化需氧量', '总氮', '总磷']
  },
  {
    index: '309',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '硫化物将在好氧反应器内氧化成硫酸盐。反应器输入端的抑制水平为 50 至 100 ppm。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['硫化物']
  },
  {
    index: '310',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '使用氯化铁作为凝结剂，可以沉淀和分离硫化物。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['硫化物']
  },
  {
    index: '311',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: '使用氯化铁沉淀硫化物时，需要选择适当的絮凝剂，因为聚集体的粒度较小。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['硫化物']
  },
  {
    index: '312',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '亚硫酸盐会在好氧反应器中被氧化成硫酸盐。如果生物反应器中的亚硫酸盐/硫酸盐含量大于 1.000 ppm，则会对污水处理质量造成影响。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['亚硫酸盐']
  },
  {
    index: '313',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '经澄清处理的污水中的亚硫酸盐/硫酸盐含量 >1.000 ppm 会影响污水处理质量。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['亚硫酸盐']
  },
  {
    index: '314',
    typeId: 'wastewater',
    category: ['砂滤池'],
    text: '总悬浮固体可提供化学需氧量值，因此必须检查砂滤入口处的总悬浮固体水平。过滤器入口处的总悬浮固体浓度应小于 100-200 ppm（小于 200-400 NTU）。在这种情况下，必须改进之前的混凝-絮凝-沉淀工艺（见总悬浮固体参数）。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '315',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '沉淀池排放时总悬浮固体流失，从而导致生化需氧量不达标（因为总悬浮固体含量），其原因可能是：污泥絮凝或污泥功能失调。污泥絮凝通常是由于生物反应器中的毒性作用（溶解氧不足、废水中存在抑制剂或有毒物质，如可吸收有机卤素和酚等）造成的。此外，总悬浮固体的损失也可能是由于丝状菌的存在。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '316',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '沉淀池排放时总悬浮固体流失，从而导致化学需氧量不达标（因为 总悬浮固体 含量），其原因可能是：污泥脱絮凝或污泥功能失调。污泥脱絮凝通常是由于生物反应器中的毒性作用（溶解氧不足、废水中存在抑制剂或有毒物质，如可吸收有机卤素和酚等）造成的。此外，总悬浮固体的损失也可能是由于丝状菌的存在。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量']
  },
  {
    index: '317',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '沉淀池排放的总悬浮固体流失，从而导致总氮不达标（因为总悬浮固体含量）的原因可能是：污泥絮凝或污泥功能失调。污泥絮凝通常是由于生物反应器中的毒性作用（溶解氧不足、废水中存在抑制剂或有毒物质，如可吸收有机卤素和酚等）造成的。此外，总悬浮固体的损失也可能是由于丝状菌的存在。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总氮']
  },
  {
    index: '318',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '沉淀池排放时总悬浮固体流失，从而导致总磷不达标（因为总悬浮固体含量）的原因可能是：污泥絮凝或污泥功能失调。污泥絮凝通常是由于生物反应器中的毒性作用（溶解氧不足、废水中存在抑制剂或有毒物质，如可吸收有机卤素和酚等）造成的。此外，总悬浮固体的损失也可能是由于丝状菌的存在。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总磷']
  },
  {
    index: '319',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '正确沉降的温度建议低于 30ºC。因此，必须检查温度是否正确。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['顏色  [m-1] (436 nm; 525 nm; 620 nm)', '砷', '硫化物']
  },
  {
    index: '320',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '正确沉降的温度建议低于 30ºC。因此，必须检查温度是否正确。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '锌',
      '铜',
      '锑',
      '镍',
      '银',
      '汞',
      '总悬浮物',
      '六价铬',
      '全价铬',
      '铅',
      '镉'
    ]
  },
  {
    index: '321',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免因苯酚抑制作用而导致沉淀池排放总悬浮固体（TSS），应检查前一单元（好氧反应器）中的苯酚含量。抑制水平为 50 至 200 ppm。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总悬浮物']
  },
  {
    index: '322',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免因可吸收有机卤素的抑制作用而导致沉淀池排放总悬浮固体（从而导致5日生化需氧量 不达标），请检查前一单元（好氧反应器）中的可吸收有机卤素水平。 抑制水平在 50 至 200 ppm 之间。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '323',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免沉淀池排放时因氰化物抑制而导致总悬浮固体流失（从而导致5日生化需氧量不达标），应检查前一单元（好氧反应器）中的氰化物含量。应避免在生物反应器输入端出现氰化物',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '324',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免沉淀池排放时因苯酚抑制而导致总悬浮固体流失（从而导致5日生化需氧量不达标），应检查前一个单元（好氧反应器）中的苯酚含量。苯酚抑制水平为 50 至 200 ppm。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '325',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免沉淀池排放时总悬浮固体流失（从而导致5日生化需氧量不达标），必须检查 pH 值。pH 值过低或过高都会导致污泥沉降速度和质量出现问题。正确的 pH 值范围为 7.2 至 8.2。pH 值过低需要加入碱性试剂（如烧碱），而 pH 值过高则需要加入酸性试剂（如硫酸或盐酸）。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '326',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免在沉淀池排放时总悬浮固体流失（从而导致5日生化需氧量不达标），应避免在反应器输入端使用油脂。油脂会降低污泥密度，严重损害污泥沉淀质量。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '327',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免沉淀池排放时总悬浮固体的流失（从而导致5日生化需氧量不达标），应避免使用硫化物。硫化物会导致活性污泥絮凝和沉降不畅。应避免在生物反应器输入端产生硫化物。为此，应正确操作之前的处理操作。参见硫化物参数中的所有操作。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '328',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免因可吸收有机卤素的抑制作用而导致沉淀池排放总悬浮固体（从而导致化学需氧量不达标），请检查前一单元（好氧反应器）中的可吸收有机卤素水平。抑制水平在 50 至 200 ppm 之间。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量']
  },
  {
    index: '329',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免沉淀池排放时因氰化物抑制而导致总悬浮固体流失（从而导致化学需氧量不达标），应检查前一单元（好氧反应器）中的氰化物含量。应避免在生物反应器输入端出现氰化物',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量']
  },
  {
    index: '330',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免因苯酚抑制作用导致沉淀池排放总悬浮固体（TSS）损失（从而导致化学需氧量不达标），请检查前一单元（好氧反应器）中的苯酚含量。苯酚抑制水平为 50 至 200 ppm。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量']
  },
  {
    index: '331',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免沉淀池排放时总悬浮固体的流失（从而导致化学需氧量不达标），必须检查 pH 值。pH 值过低或过高都会导致污泥沉降速度和质量出现问题。正确的 pH 值范围为 7.2 至 8.2。pH 值过低需要添加碱性试剂（如烧碱），而 pH 值过高则需要添加酸性试剂（如硫酸或盐酸）。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量']
  },
  {
    index: '332',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免在沉淀池排放时总悬浮固体流失（从而导致化学需氧量不达标），应避免在反应器输入端使用油脂。油脂会降低污泥密度，严重破坏污泥沉淀质量。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量']
  },
  {
    index: '333',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免沉淀池排放时总悬浮固体的流失（从而导致化学需氧量不达标），应避免使用硫化物。硫化物会导致活性污泥絮凝和沉降不畅。应避免在生物反应器输入端产生硫化物。为此，应正确操作之前的处理操作。参见硫化物参数中的所有操作。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量']
  },
  {
    index: '334',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免在沉淀池排放时总悬浮固体（TSS）流失（从而因固体含量导致总悬浮固体不达标），必须检查 pH 值。pH 值过低或过高都会导致污泥沉降速度和质量出现问题。正确的 pH 值范围为 7.2 至 8.2。pH 值过低需要加入碱性试剂（如烧碱），而 pH 值过高则需要加入酸性试剂（如硫酸或盐酸）。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总悬浮物']
  },
  {
    index: '335',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免在沉淀池排放时总悬浮固体流失（从而导致总悬浮固体不达标），应避免在反应器输入端加入油脂。油脂会降低污泥密度，严重损害污泥沉淀质量。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总悬浮物']
  },
  {
    index: '336',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免因可吸收有机卤素的抑制作用而导致沉淀池排放时总悬浮固体流失（从而导致总氮不达标），请检查前一个单元（好氧反应器）中的可吸收有机卤素水平。 抑制水平在 50 至 200 ppm 之间。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总氮']
  },
  {
    index: '337',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免沉淀池排放时因氰化物抑制而导致总悬浮固体流失（从而导致总氮不达标），应检查前一单元（好氧反应器）中的氰化物含量。应避免在生物反应器输入端出现氰化物',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总氮']
  },
  {
    index: '338',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免在沉淀池排放时因苯酚抑制而导致总悬浮固体流失（从而导致总氮不达标），请检查前一个单元（好氧反应器）中的苯酚含量。苯酚抑制水平为 50 至 200 ppm。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总氮']
  },
  {
    index: '339',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免沉淀池排放时总悬浮固体流失（从而导致总氮不达标），必须检查 pH 值。pH 值过低或过高都会导致污泥沉降速度和质量出现问题。正确的 pH 值范围为 7.2 至 8.2。pH 值过低需要加入碱性试剂（如烧碱），而 pH 值过高则需要加入酸性试剂（如硫酸或盐酸）。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总氮']
  },
  {
    index: '340',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免在沉淀池排放时总悬浮固体流失（从而导致总氮不达标），应避免在反应器输入端加入油脂。油脂会降低污泥密度，严重损害污泥沉淀质量。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总氮']
  },
  {
    index: '341',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免在沉淀池排放时总悬浮固体流失（从而导致总氮不达标），应避免使用硫化物。硫化物会造成活性污泥的絮凝和沉降不良。应避免在生物反应器输入端产生硫化物。为此，应正确操作之前的处理操作。参见硫化物参数中的所有操作。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总氮']
  },
  {
    index: '342',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免在沉淀池排放时因氰化物抑制而导致总悬浮固体流失（从而因固体含量而导致总磷不达标），应检查前一单元（好氧反应器）中的氰化物含量。应避免在生物反应器输入端出现氰化物',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总磷']
  },
  {
    index: '343',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免因可吸收有机卤素的抑制作用而导致沉淀池排放总悬浮固体（从而导致总磷不达标），请检查前一个单元（好氧反应器）中的可吸收有机卤素水平。抑制水平在 50 至 200 ppm 之间。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总磷']
  },
  {
    index: '344',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免因苯酚抑制作用而导致沉淀池排放总悬浮固体（TSS）损失（从而导致总磷不达标），请检查前一个单元（好氧反应器）中的苯酚含量。苯酚抑制水平为 50 至 200 ppm。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总磷']
  },
  {
    index: '345',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免在沉淀池排放时总悬浮固体流失（从而导致总磷不达标），必须检查 pH 值。pH 值过低或过高都会导致污泥沉降速度和质量出现问题。正确的 pH 值范围为 7.2 至 8.2。pH 值过低需要加入碱性试剂（如苛性钠），而 pH 值过高则需要加入酸性试剂（如硫酸或盐酸）。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总磷']
  },
  {
    index: '346',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免在沉淀池排放时总悬浮固体流失（从而导致总磷不达标），应避免在反应器输入端使用油脂。油脂会降低污泥密度，严重破坏污泥沉淀质量。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总磷']
  },
  {
    index: '347',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免在沉淀池排放时总悬浮固体流失（从而导致总磷不达标），应避免使用硫化物。硫化物会造成活性污泥的絮凝和沉降不良。应避免在生物反应器输入端产生硫化物。为此，应正确操作之前的处理操作。查看硫化物参数中的所有操作。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总磷']
  },
  {
    index: '348',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为了避免沉淀池排放时总悬浮固体的流失，总悬浮固体不达标的原因可能是：污泥絮凝或污泥功能失调。污泥脱絮凝通常是由于生物反应器中的毒性作用（溶解氧不足、废水中存在抑制剂或有毒物质，如可吸收有机卤素和酚类、氰化物等）。此外，总悬浮固体的损失也可能是由于丝状菌的存在。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总悬浮物']
  },
  {
    index: '349',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免沉淀池排放时总悬浮固体因可吸收有机卤素的抑制作用而流失，应检查前一单元（好氧反应器）中的可吸收有机卤素含量。 抑制水平在 50 至 200 ppm 之间。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总悬浮物']
  },
  {
    index: '350',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免沉淀池排放时因氰化物抑制而导致总悬浮固体损失，应检查前一单元（好氧反应器）的氰化物含量。应避免在生物反应器输入端出现氰化物',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总悬浮物']
  },
  {
    index: '351',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免总悬浮固体（TSS）在沉淀池排放时流失，需要密切控制污泥容积指数（SVI），其值应保持在小于 150 毫升/克。SVI 用于描述活性污泥法曝气池中污泥的沉降特性。其定义为 1 克活性污泥沉淀 30 分钟后所占的体积（毫升）。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总氮', '化学需氧量', '总磷', '总悬浮物', '5日生化需氧量']
  },
  {
    index: '352',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免总悬浮固体在沉淀池排放时流失，必须检查水的电导率是否正确。高电导率/高盐度会降低活性污泥沉淀性能。反应器输入端的氯化物含量应小于 10.000 ppm，硫酸盐含量应小于 1.000 ppm，这样才能达到正确的性能。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总悬浮物']
  },
  {
    index: '353',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免总悬浮固体在沉淀池排放时流失，必须检查水的电导率是否正确。电导率的突然变化会导致沉淀池发生故障。均化和浓度平衡是反应器正常运行的关键。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总悬浮物']
  },
  {
    index: '354',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '为避免总悬浮固体在沉淀池中流失，应避免硫化物。硫化物会导致活性污泥絮凝和沉降不良。应避免在生物反应器输入端产生硫化物。为此，应正确操作之前的处理操作。查看硫化物参数中的所有操作。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总悬浮物']
  },
  {
    index: '355',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '为避免生物反应器输入端的总固体含量增加，前面的步骤必须运行良好（条形筛和混凝/絮凝装置的正确运行）。总悬浮固体过量会导致耗氧量（SOUR：比氧吸收率）急剧下降。这会对反应器的稳定性造成危害。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总悬浮物']
  },
  {
    index: '356',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '为避免生物反应器输入端的总固体含量增加，前面的步骤必须运行良好（条形筛和混凝/絮凝装置的正确运行）。生物反应器输入端的总悬浮固体应考虑到污泥浪费率的调整。为了避免废水中的固体物质过多地进入反应器，生物反应器输入端的总悬浮固体浓度不应大于 100 ppm。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总悬浮物']
  },
  {
    index: '357',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '为避免5日生化需氧量性能出现故障，应避免在反应器输入端使用油脂。油和油脂是不可生物降解的，因为它们不溶，可能会导致活性污泥严重功能障碍，如氧气转移不良和丝状等不沉降细菌的存在。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '358',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '为避免化学需氧量性能失调，应避免在反应器输入端使用油脂。油脂不可生物降解，因为它们不溶于水，会导致活性污泥出现严重的功能失调，如氧气传输不畅和丝状菌等非沉降菌的存在。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量']
  },
  {
    index: '359',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '为避免总悬浮固体性能失调，应避免在反应器输入端使用油脂。油脂不可生物降解，因为它们不溶于水，可能会导致活性污泥出现严重的功能障碍，如氧传递不良和出现丝状菌等非沉降菌。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总悬浮物']
  },
  {
    index: '360',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '为避免总磷性能失调，应避免在反应器输入端使用油脂。油脂不可生物降解，因为它们不溶于水，可能会导致活性污泥出现严重的功能障碍，如氧传递不良和出现丝状菌等非沉降菌。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总磷']
  },
  {
    index: '361',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '为避免总氮性能失调，应避免在反应器输入端使用油脂。油脂不可生物降解，因为它们不溶于水，会导致活性污泥出现严重的功能失调，如氧气传输不畅和丝状菌等非沉降菌的存在。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总氮']
  },
  {
    index: '362',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '为避免5日生化需氧量不达标，必须密切控制工艺，特别是 SOUR 反应器控制。此外，抑制剂会导致生物反应器性能严重失调（应避免在反应器输入端使用以下参数： 可吸收有机卤素、酚类、特定含量的重金属、硫化物、亚硫酸盐和螨虫）。检查抑制剂水平以及如何减少特定参数的作用。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '363',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '为避免化学需氧量不达标，必须密切控制工艺，特别是 SOUR 反应器控制。此外，化学需氧量抑制剂会导致生物反应器性能严重失调（应避免在反应器输入端使用以下参数： 可吸收有机卤素、酚类、某些含量的重金属、硫化物、亚硫酸盐和氨氮）。检查抑制剂水平以及如何减少特定参数的作用。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量']
  },
  {
    index: '364',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '为避免总磷不达标，必须密切控制工艺，特别是 SOUR 反应器控制。此外，抑制剂会导致生物反应器性能严重失调（应避免在反应器输入端使用以下参数： 可吸收有机卤素、酚类、特定含量的重金属、硫化物、亚硫酸盐和螨虫）。检查抑制剂水平以及如何减少特定参数的作用。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总磷']
  },
  {
    index: '365',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '为避免总氮不达标，必须对工艺进行严密控制，特别是 SOUR 反应器控制。此外，抑制剂会导致生物反应器性能严重失调（应避免在反应器输入端使用以下参数： 可吸收有机卤素、酚类、特定含量的重金属、硫化物、亚硫酸盐和螨虫）。检查抑制剂水平，以及如何减少特定参数的作用。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总氮']
  },
  {
    index: '366',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '为避免化学需氧量不达标，应根据需要控制的化学参数类型选择活性炭性质。应根据过滤器制造商的建议选择颗粒大小、孔径和碳类型。检查水的成分是否发生了变化，是否需要改变活性炭类型或颗粒大小。请记住，极性物质和低分子量物质在活性炭孔隙中的滞留能力较弱。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['化学需氧量']
  },
  {
    index: '367',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '总铬浓度大于 1 至 100 ppm 时，对活性污泥具有生物毒性，应避免在反应器输入端使用。预计不会进行处理。应避免在活性污泥中积累。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['全价铬']
  },
  {
    index: '368',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '在生物反应器中减少可生物降解的氮总量，需要一个硝化/反硝化的组合过程。需要一种特殊的工艺设计，将硝化的好氧反应器和反硝化的缺氧反应器结合起来。另一方面，不可生物降解的氮或缺乏硝化/反硝化技术将导致反应器和沉淀池二沉池中氮的总浓度增加。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总氮']
  },
  {
    index: '369',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '总铬不能被络合。这意味着它们不能形成络合物。金属络合物是一个或多个金属原子与一个或多个配体结合的化合物。配体是能够通过一个或多个原子与金属中心结合的有机化合物。因此，金属必须是游离的，这样才能通过物理化学处理将其去除。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['全价铬']
  },
  {
    index: '370',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: 'V30´ 测量值和 SVI 值应保持小于 150 毫升/克，以控制沉淀池排放时可能出现的总悬浮固体损失，避免总悬浮固体不达标。在以下情况下，固体含量不会对沉淀过程产生重大影响：固体含量小于或等于 150 ppm，并且这些固体不会降低絮凝物的密度。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总悬浮物']
  },
  {
    index: '371',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '建议在配料点采用极高的混合强度（G 值在 200 到 300 秒-1 之间）。高能量混合时间一般为 10 至 30 秒。在混合操作之后，应进行电流凝固。反应池必须充分混合，没有死体积。混合泵 > 100 罐体积/小时。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '锌',
      '砷',
      '铜',
      '锑',
      '镍',
      '银',
      '汞',
      '六价铬',
      '全价铬',
      '铅',
      '镉'
    ]
  },
  {
    index: '372',
    typeId: 'wastewater',
    category: ['活性炭过滤器'],
    text: '建议在活性炭过滤器输入时采用极低的总悬浮固体含量。小于 2.5 ppm（< 5 NTU），以避免过滤污染。因此，应检查该设备进水口的水浊度。如果浊度超过 5 NTU，则应加强压力砂滤器的处理。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 2'],
    parameter: ['总悬浮物']
  },
  {
    index: '373',
    typeId: 'wastewater',
    category: ['沉淀池'],
    text: '堰流速应小于 4 立方米/小时/米',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '锌',
      '硫化物',
      '砷',
      '铜',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '油和油脂',
      '镍',
      '银',
      '汞',
      '总悬浮物',
      '六价铬',
      '全价铬',
      '铅',
      '镉'
    ]
  },
  {
    index: '374',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '当碱度较高时，可使用强中和剂，如矿物酸 H2SO4/HCl 和 NaOH。应考虑缓冲作用。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['PH值']
  },
  {
    index: '375',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '在使用 Al 聚氯化物时，混凝-絮凝反应的 pH 值控制非常重要，建议 pH 值保持在 6.5-7.5 之间。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['顏色  [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '376',
    typeId: 'wastewater',
    category: ['收集池'],
    text: '在使用空气作为氧化剂、化粪池控制剂或混合剂时，以及在使用二氧化碳稀释比例较高的水体时，由于二氧化碳的汽提作用，pH 值可达到 8-9，呈碱性。 在这种情况下，必须添加酸性试剂，将 pH 值调整到下一步所用混凝剂的最佳值。这种 pH 值设置可在收集池或混凝池中进行',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['PH值']
  },
  {
    index: '377',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '锌可以氢氧化物的形式沉淀。使用氢氧化钠或石灰作为试剂，在 pH 值为 9 - 9.5 至 11 时，锌的溶解度最小。使用这两种试剂会得到相似的结果。沉淀对 pH 值很敏感，因为形成的沉淀会被重新稀释。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['锌']
  },
  {
    index: '378',
    typeId: 'wastewater',
    category: ['凝结'],
    text: '锌不能被络合。这意味着它们不能形成络合物。金属络合物是一个或多个金属原子与一个或多个配体结合的化合物。配体是能够通过一个或多个原子与金属中心结合的有机化合物。因此，金属必须是游离的，这样才能通过物理化学处理将其去除。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['锌']
  },
  {
    index: '379',
    typeId: 'wastewater',
    category: ['二沉池·'],
    text: '锌浓度大于 0.3 至 5 ppm 时，对活性污泥具有生物毒性，应避免在反应器输入端使用。预计不会进行处理。 应避免在活性污泥中积累。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['锌']
  },
  {
    index: '380',
    typeId: 'wastewater',
    category: ['凝结'],
    text: 'pH 探头必须清洁和校准（建议每周校准一次）。如果 pH 传感器不能正确测量，而调整 pH 值的试剂剂量又与传感器的读数有关，就会导致该参数不达标。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: ['PH值']
  },
  {
    index: '381',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '生物反应器中的 pH 值范围为 7.2 至 8.2。通常需要进行 pH 值校正。 pH 值过低需要加入碱性试剂（如烧碱），而 pH 值过高则需要加入酸性试剂（如硫酸或盐酸）。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['化学需氧量']
  },
  {
    index: '382',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '生物反应器中的 pH 值范围为 7.2 至 8.2。通常需要进行 pH 值校正。pH 值过低需要加入碱性试剂（如烧碱），而 pH 值过高则需要加入酸性试剂（如硫酸或盐酸）。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['5日生化需氧量']
  },
  {
    index: '383',
    typeId: 'wastewater',
    category: ['好氧反应器'],
    text: '生物反应器中的 pH 值范围为 7.2 至 8.2，通常需要进行 pH 校正。 pH 值过低时需要加入碱性试剂（如烧碱），pH 值过高时需要加入酸性试剂（如硫酸或盐酸）。',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 3'],
    parameter: ['总氮', '总磷']
  },
  {
    index: '384',
    typeId: 'wastewater',
    category: ['絮凝'],
    text: 'pH 值 >8 u 会影响某些阴离子聚电解质的絮凝能力',
    manufacturingProcess: [
      '连续染色',
      '浸染法',
      '水洗',
      '皮革',
      '匹印',
      '定位印花',
      '其他'
    ],
    etpType: ['废水处理设施类型 1', '废水处理设施类型 3', '废水处理设施类型 2'],
    parameter: [
      '铜',
      '总氮',
      '镉',
      '油和油脂',
      '化学需氧量',
      '银',
      '总磷',
      '汞',
      '全价铬',
      '5日生化需氧量',
      '铅',
      '锌',
      '砷',
      '总悬浮物',
      '六价铬',
      '硫化物',
      '锑',
      '顏色  [m-1] (436 nm; 525 nm; 620 nm)',
      '镍'
    ]
  }
];
